export default __webpack_public_path__ + "static/media/destination-single-gallery-8-313x234.18342f49.jpg";